import { Base } from '../base-component';
import './category-faq.component.scss';

export class CategoryFaq extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() { }

	bindEvents() { }

}



// WEBPACK FOOTER //
// ./components/category-faq/category-faq.component.ts